import { Box, Button } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { ConflictingSlot } from "../types";

type ReservedSlotContentProps = {
    conflictingSlots: Array<ConflictingSlot>;
};

export const ReservedSlotContent = ({ conflictingSlots }: ReservedSlotContentProps) => {
    return (
        <>
            Este horário está reservado permanentemente para o cliente{" "}
            {conflictingSlots.map((slot, index) => (
                <Box key={slot.servicesProvidedId} component="span">
                    {index > 0 && ", "}
                    <Button
                        component={Link}
                        to={`/treatments/${slot.treatmentId}/treatment_prescription`}
                        target="_blank"
                        variant="text"
                        color="secondary"
                        size="small"
                        endIcon={<OpenInNew sx={{ fontSize: 14 }} />}
                        sx={{ textTransform: "none", p: 0, minWidth: "auto", fontWeight: 600, verticalAlign: "baseline" }}
                    >
                        {slot.clientName}
                    </Button>
                </Box>
            ))}
            <br /> <br /> Introduzir um motivo para agendar neste horário reservado
        </>
    );
};

